import { render, staticRenderFns } from "./VInventoryReceive.vue?vue&type=template&id=7f5c0e02"
import script from "./VInventoryReceive.vue?vue&type=script&lang=js"
export * from "./VInventoryReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports